module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ChapTitle1",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "DropText"
  }, [_c('span', {
    staticClass: "DropCap"
  }, [_vm._v("A")]), _vm._v(" voice, certainly—any book is a voice—but why from the Attic?")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("In this book I want to comment and digress on some aspects of the world of books today, by no means always seriously and certainly not with any desire to impose my taste on anyone; rather, I expose my taste hoping that it may provide diversion for the reader. I do this as one who, for twenty years, reviewed books for a living (or part of a living, for I never found that it provided a whole one) and as one who has given hard knocks as a reviewer and taken them as an author. Because I am a Canadian, my outlook may possess some novelty for readers in the United States, for my country sees not only the greater part of the books produced in yours, but those published in Great Britain as well—not to speak of our own books. Canada is, I believe, the only country so blessed.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Statesmen are fond of stressing Canada’s role as a mediator between the United States and Great Britain. Sometimes for us in Canada it seems as though the United States and the United Kingdom "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("were cup and saucer, and Canada the spoon, for we are in and out of both with the greatest freedom, and we are given most recognition when we are most a nuisance. If, in these reflections, I seem not to be committed to either side, it is because I am a Canadian, and of Canada one of our poets, Patrick Anderson, has said:")]), _vm._v(" "), _c('p', {
    staticClass: "Extract3"
  }, [_vm._v("… I am one and none, pin and pine, snow and slow, America’s attic …")]), _vm._v(" "), _c('p', {
    staticClass: "Text1"
  }, [_vm._v("—and that is why this is A Voice from the Attic.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e788f10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0005.vue
// module id = 75
// module chunks = 0